<template>
  <div v-show="isLoaded" class="mCDraw_container" v-observe-visibility="startAnimate">
    <h1 class="mCDraw_title" :class="{animate: animate}">Próximamente</h1>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "CDraw",
    data() {
        return {
            animate: false,
            isSafari: false,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {
        window.scrollTo(0,0)
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/CDraw.scss";
</style>